import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  > label {
    margin-bottom: 12px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.grey};
    opacity: 0.7;
  }

  > textarea {
    resize: unset;
    background: transparent;
    border: 0px;
    border-bottom: ${props =>
      props.error ? '1px solid #e53935' : '1px solid #ddd'};
  }

  > span {
    position: absolute;
    top: 45px;
    color: ${({ theme }) => theme.colors.error};
    font-size: 10px;
    font-weight: bold;
  }
`;
